import { coesOrderResumeData } from './types';

interface CoesTableTemplateProps {
  data: coesOrderResumeData[];
  assetCount: number;
  totalValue: string;
}

export const coesTableTemplate = ({ assetCount, data, totalValue }: CoesTableTemplateProps) => {
  if (assetCount === 0) {
    return '';
  }

  return `
      <div class="product-card">
        <strong class="product-type-title">OPERAÇÕES ESTRUTURADAS</strong>
        <div class="product-info">
          <span class="product-info-text">${assetCount} Ativo(s)</span>
          <span class="product-info-text">Total ${totalValue}</span>
        </div>
      </div>
      <div class="product-table">
        <div class="highlight-bar coes"></div>
        <div class="product-table-content">
          <table>
            <thead>
              <tr>
                <th style="width: 80px;">ativo</th>
                <th style="width: 40px;">estratégia</th>
                <th style="width: 30px;">vencimento</th>
                <th style="width: 40px;">risco</th>
                <th style="width: 40px;">aplic. mínima</th>
                <th style="width: 40px;">aplicação em</th>
                <th style="width: 30px;">valor</th>
              </tr>
            </thead>
            <tbody>
             ${data.map((item) => {
               return `<tr>
                <td>${item.productDisplay}</td>
                <td>${item.strategy}</td>
                <td>${item.maturityDate}</td>
                <td>${item.riskRating}</td>
                <td>${item.minApplicationValueFormatted}</td>
                <td>${item.applicationIn}</td>
                <td>${item.valueAppliedFormatted}</td>
              </tr>`;
             })}
            </tbody>
          </table>
        </div>
      </div>
      `;
};
